// What to call an invoice's job in lists. Ferrari jobs go by their order
// numbers (packageDetails[].number, "NYW600356422 +1"); their job number is an
// internal FX-#### or, on older invoices, often blank. Everything else by its
// job number as before. Mirrors jobDisplayNumber() for jobs.
export function invoiceLabel(inv) {
  const isFerrari = /ferrari/i.test(`${inv?.brokerName || ""} ${inv?.dispatcherName || ""}`);
  const orders = [...new Set((inv?.packageDetails || []).map((p) => String(p?.number || "").trim()).filter(Boolean))];
  if (isFerrari && orders.length) return orders.length > 1 ? `${orders[0]} +${orders.length - 1}` : orders[0];
  return inv?.jobNumber || orders[0] || "";
}
